import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyB6lKC4dYLoW4yT3sIXYWD8vJpxO_lxPms',
  authDomain: 'pathpoint-97f27.firebaseapp.com',
  projectId: 'pathpoint-97f27',
  storageBucket: 'pathpoint-97f27.firebasestorage.app',
  messagingSenderId: '352970398096',
  appId: '1:352970398096:web:6f456d8749de95ca0b3b15',
  measurementId: 'G-0350QYM9NZ',
};

export const firebaseApp = initializeApp(FIREBASE_CONFIG);
export const analytics = getAnalytics(firebaseApp);
